




















import { Vue, Component, Prop, Watch, Ref } from 'vue-property-decorator';
import {Grid} from '@toast-ui/vue-grid';
import {State} from 'vuex-class';
import CompSelectBox from '@/components/common/CompSelectBox.vue';
import GridColumnsLayer from '@/components/common/grid/GridColumnsLayer.vue';
import {i18nAllObject} from '@/utils/i18n';
import {changeDateFormat} from '@/utils/dateUtils';
import {writeExcel} from '@/utils/excel';
import {GridNameType} from 'supporter';
import {RowKey} from 'tui-grid';
import {GridEventProps} from 'tui-grid/types/event';

@Component({
  components: {CompSelectBox, GridColumnsLayer}
})
export default class ItemTable extends Vue {
  @Prop({ default: null })
  private readonly onItemClicked: (gridProp) => void;
	
	@Prop({ default: null })
	private readonly onRowChecked: (gridProp) => void;
  
  @Prop() private option?: any;
  private initOver = false;
  private itemInfo: any = {
    name: 'grid',
    gridName: '',
    autoHeight: false,
    showTopcontent: true,
    nonDataBodyHeight: 190,
    haveDataBodyHeight: 480,
    haveRigthBtn: true,
    haveConfigBtn: true,
    havePageSizeBtn: true,
    haveExcelDownBtn: true,
    noBorder: false,
    onLoadSearch: true,
    keepScrolling: false,
    excelDownInfo: null as any,
    pageSize: '30',
    pageSizes: [
      {
        value: '30',
        name: 'COMMON_PAGE_SIZE_30'
      },
      {
        value: '50',
        name: 'COMMON_PAGE_SIZE_50'
      },
      {
        value: '100',
        name: 'COMMON_PAGE_SIZE_100'
      },
      {
        value: '200',
        name: 'COMMON_PAGE_SIZE_200'
      }
    ]
  };

  private showColumns: any = [];
  private columnsOrder: any = [];
  private defaultColumnsOrder: any = [];
  private disabledCnt = 0;

  private showEditLayer = false;

  @Prop({required: true})
  private gridProps!: any;
  @Prop({required: true})
  private data!: [];
  @Prop({default: 0})
  private totalCount!: number;

  @State private onGnb!: boolean;
  @Watch('onGnb')
  onGnbChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    if (grid) {
      grid.invoke('refreshLayout');
    }
  }

  private changePageSize(value: any) {
    this.$emit('resetData', 1, Number(value));
  }

  @Watch('data')
  onDataChanged() {
    const grid = this.$refs.tuiGrid as Grid;
    const pagination = grid.invoke('getPagination') as any;
    const heightScrollTo = this.itemInfo.keepScrolling ? this.$el.querySelector('.tui-grid-body-area').scrollTop : 0;
    if (!this.itemInfo.autoHeight) {
      grid.invoke('setBodyHeight', this.data.length === 0 ? this.itemInfo.nonDataBodyHeight : this.itemInfo.haveDataBodyHeight);
    }

    if (pagination) {
      const pageState = {
        totalCount: this.totalCount,
        page: this.gridProps.options.pageOptions.page,
        perPage: this.gridProps.options.pageOptions.perPage
      };

      grid.invoke('resetData', this.data as any, {pageState});
    } else {
      grid.invoke('resetData', this.data as any);
    }
    if (!this.data || this.data.length === 0) {
      grid.invoke('disable');
    } else {
      grid.invoke('enable');
    }
    this.$nextTick(() => {
      grid.invoke('refreshLayout');
    });
    if (typeof this.itemInfo.afterFunction === 'function') {
      this.$nextTick(() => {
        this.itemInfo.afterFunction();
      });
    }
    if (this.itemInfo.keepScrolling) {
      this.$nextTick(() => {
        this.$el.querySelector('.tui-grid-body-area').scrollTop = heightScrollTo;
      });
    }
  }

  private excelDown() {
    if (this.data && this.data.length > 0) {
      let columns = i18nAllObject(this, this.itemInfo.excelDownInfo.columns);
      let fileName = this.itemInfo.excelDownInfo.fileName;
      if (this.itemInfo.excelDownInfo.nameDateFormat !== undefined) {
        fileName += changeDateFormat(new Date(), this.itemInfo.excelDownInfo.nameDateFormat);
      }
      writeExcel(this.data, columns, fileName, this.itemInfo.excelDownInfo.formatters);
    } else {
      if (this.itemInfo.excelDownInfo.noDataMsg) {
        alert(this.$t(this.itemInfo.excelDownInfo.noDataMsg));
      } else {
        alert(this.$t('COMMON_NOT_DATA'));
      }
    }
  }

  public gridFunction(functionKey: any, params?: any) {
    if (params) {
      return (this.$refs.tuiGrid as Grid).invoke(functionKey, ...params);
    } else {
      return (this.$refs.tuiGrid as Grid).invoke(functionKey);
    }
  }

  public getCheckedRowKeys() {
    return (this.$refs.tuiGrid as Grid).invoke('getCheckedRowKeys');
  }
  public getRowAt(key: any) {
    return (this.$refs.tuiGrid as Grid).invoke('getRowAt', key);
  }
  public getCheckedRows() {
    return (this.$refs.tuiGrid as Grid).invoke('getCheckedRows');
  }
  public getCheckedItems(propName: string) {
    const grid = this.$refs.tuiGrid as Grid;
    const items = grid.invoke('getCheckedRows').map((item) => item[propName]);
    return items.join(',');
  }
  public getFocusedCell() {
    return (this.$refs.tuiGrid as Grid).invoke('getFocusedCell');
  }
  public getData() {
    return (this.$refs.tuiGrid as Grid).invoke('getData');
  }
  public checkRow(rowKey): void {
    (this.$refs.tuiGrid as Grid).invoke('check', rowKey);
  }
  public disableRowCheck(rowKey: any) {
    return (this.$refs.tuiGrid as any).invoke('disableRowCheck', rowKey);
  }
  public addRowGray(i: number) {
    const grid = this.$refs.tuiGrid as Grid;
    return grid.invoke('addRowClassName', i, 'gray');
  }
  public removeRowGray(i: number) {
    const grid = this.$refs.tuiGrid as Grid;
    return grid.invoke('removeRowClassName', i, 'gray');
  }
  
  public removeCheckedRows(showConfirm?: boolean) {
    return (this.$refs.tuiGrid as Grid).invoke('removeCheckedRows', showConfirm ?? false);
  }
  
  public getRow(rowKey: any) {
    return (this.$refs.tuiGrid as Grid).invoke('getRow', rowKey);
  }
  public setRow(rowKey: number, row) {
    const grid = this.$refs.tuiGrid as Grid;
    grid.invoke('setRow', rowKey, row);
  }
  private async initOption() {
    if (this.option) {
      this.itemInfo = Object.assign({}, this.itemInfo, { ...this.option });
      Object.assign(this.itemInfo, this.option);
    }
    if (this.itemInfo.gridName) {
      this.defaultColumnsOrder = this.gridProps.columns.map((column: any, idx: number) => {
        return {
          columnName: column.name,
          displayOrder: idx + 1,
          visible: true,
          showName: column.header
        };
      });
      if (this.gridProps.options.columnOptions && this.gridProps.options.columnOptions.frozenCount) {
        this.disabledCnt = this.gridProps.options.columnOptions.frozenCount;
      }
      let gridLayouts = await this.$api.getGridLayouts({params: {gridName: this.itemInfo.gridName as GridNameType}});

      gridLayouts.data.forEach((layoutInfo: any) => {
        let tempColumn = this.gridProps.columns.find((column: any) => layoutInfo.columnName === column.name);
        if (tempColumn) {
          if (layoutInfo.visible) {
            this.showColumns.push(tempColumn);
          }

          this.columnsOrder.push({
            columnName: layoutInfo.columnName,
            displayOrder: layoutInfo.displayOrder,
            visible: layoutInfo.visible,
            showName: tempColumn.header
          });
        }
      });
      if (this.columnsOrder.length < this.gridProps.columns.length) {
        this.gridProps.columns.forEach((column: any) => {
          if (this.columnsOrder.every((layoutInfo: any) => layoutInfo.columnName !== column.name)) {
            this.showColumns.push(column);
            this.columnsOrder.push({
              columnName: column.name,
              displayOrder: this.columnsOrder.length + 1,
              visible: true,
              showName: column.header
            });
          }
        });
      }
    } else {
      this.showColumns = this.gridProps.columns;
    }
    if (this.gridProps && this.gridProps.options && this.gridProps.options.pageOptions) {
      if (this.gridProps.options.pageOptions.centerAlign === undefined) {
        this.gridProps.options.pageOptions.centerAlign = true;
      }
    }
    if (this.gridProps && this.gridProps.options) {
      if (this.gridProps.options.columnOptions) {
        if (this.gridProps.options.columnOptions.resizable === undefined) {
          this.gridProps.options.columnOptions.resizable = true;
        }
      } else {
        this.gridProps.options.columnOptions = {resizable: true};
      }
    }
    this.initOver = true;
  }

  private onClick(ev) {
    if (ev.targetType === 'cell') {
      const {radioBtn} = ev.instance.store.column.allColumnMap;
      if (radioBtn) {
        const radio = $('.tui-grid-cell-current-row input[type="radio"]');
        if (radio) {
          radio.prop('checked', true);
          ev.instance.uncheckAll();
          ev.instance.check(ev.rowKey);
        }
      }
    }
  }

  private async mounted() {
    await this.initOption();
    const grid = this.$refs.tuiGrid as Grid;
    
    this.bindGridEvent();

    const pagination = grid.invoke('getPagination');
    if (pagination) {
      grid.invoke('on', 'beforePageMove', (ev: any) => {
        this.$emit('resetData', ev.page);
        ev.stop();
      });
    }

    grid.invoke('on', 'mousedown', (ev: any) => {
      if (ev.targetType === 'columnHeader') {
        $('th[data-column-name="' + ev.columnName + '"]').removeClass('tui-grid-cell-selected');
      }
      let tagName = ev.nativeEvent.target.tagName;
      if (tagName === 'SELECT' || tagName === 'INPUT') {
        ev.stop();
      }
    });

    if (this.itemInfo.onLoadSearch) {
      this.$emit('resetData', 1);
    }
    if (!this.data || this.data.length === 0) {
      grid.invoke('disable');
    }
  }
	
	private invokeRowChecked(checkType: string, selected: RowKey[], gridProps: GridEventProps) {
		this.onRowChecked && this.onRowChecked({ checkType: checkType, selected: selected, ...gridProps });
	}
	
  @Ref('tuiGrid')
  private readonly gridRef: Grid;
  private bindGridEvent() {
	  // check 관련 이벤트를 proxy
	  this.gridRef.invoke('on', 'check', gridEvent => {
		  this.invokeRowChecked('check', this.getCheckedRowKeys(), gridEvent as GridEventProps);
	  });
	  this.gridRef.invoke('on', 'uncheck', gridEvent => {
		  this.invokeRowChecked('uncheck', this.getCheckedRowKeys(), gridEvent as GridEventProps);
	  });
	  this.gridRef.invoke('on', 'checkAll', gridEvent => {
		  this.invokeRowChecked('checkAll', this.getCheckedRowKeys(), gridEvent as GridEventProps);
	  });
	  this.gridRef.invoke('on', 'uncheckAll', gridEvent => {
		  this.invokeRowChecked('uncheckAll', this.getCheckedRowKeys(), gridEvent as GridEventProps);
	  });
	
	  // SELECT, INPUT 인 경우 네이티브 동작하도록
	  this.gridRef.invoke('on', 'mousedown', gridEvent => {
		  const tagName = (gridEvent as any).nativeEvent.target.tagName; // eslint-disable-line
		  if (tagName === 'SELECT' || tagName === 'INPUT') {
			  gridEvent.stop();
		  }
	  });
    // check 시 클릭 이벤트 발동 안되도록
    this.gridRef.invoke('on', 'click', (gridProp) => {
      if ((gridProp as any).columnName !== '_checked') {
        this.onItemClicked && this.onItemClicked(gridProp);
      }
    });
  }

  updated() {
    const grid = this.$refs.tuiGrid as Grid;
    if (this.itemInfo.name === 'feePolicyDetailResultTable') {
      grid.invoke('addColumnClassName', 'finalSettlementAmt', 'orange');
      grid.invoke('addColumnClassName', 'finalAdjustedSettlementAmt', 'orange');
    } else if (this.itemInfo.name === 'inquiry_list') {
      if (this.data) {
        this.data.forEach((item: any) => {
          if (item.delayed) {
            grid.invoke('addCellClassName', item.rowKey, 'issuedDateTime', 'text-red');
          }
        });
      }
    }
  }
}
